import type { ComponentProps } from "react";

import { forwardRef } from "react";

const IconFile = forwardRef<SVGSVGElement, ComponentProps<"svg">>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M4.89841 1.5H3.04175C2.54447 1.5 2.06755 1.69754 1.71592 2.04917C1.36429 2.40081 1.16675 2.87772 1.16675 3.375V14.625C1.16675 15.1223 1.36429 15.5992 1.71592 15.9508C2.06755 16.3025 2.54447 16.5 3.04175 16.5H10.5417C11.039 16.5 11.5159 16.3025 11.8676 15.9508C12.2192 15.5992 12.4167 15.1223 12.4167 14.625V9M4.89841 1.5C5.93425 1.5 6.79175 2.33917 6.79175 3.375V5.25C6.79175 5.74728 6.98929 6.22419 7.34092 6.57582C7.69255 6.92746 8.16947 7.125 8.66675 7.125H10.5417C11.039 7.125 11.5159 7.32254 11.8676 7.67417C12.2192 8.02581 12.4167 8.50272 12.4167 9M4.89841 1.5C7.97341 1.5 12.4167 5.96667 12.4167 9M4.50008 12.75H9.50008M4.50008 10.25H7.83341"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
IconFile.displayName = "IconFile";

export { IconFile };
